import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

const usePostExam = (answerList) => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()
    const [, setConfirm] = useConfirmModalAtom()

    const request = () => {
        setConfirm("응시를 완료하시겠습니까?", () => () => {
            console.log("제출", answerList)
            fetchRequest("POST", `/tryout/payment/${idx}`, {
                "answer_list": JSON.stringify(answerList)
            })
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(`/tryout/payment/${idx}/result`)
                break
            case 400:
                if (fetchResult?.data?.error_code === "payment_idx") setAlert("결제 idx 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "answer_list") setAlert("모든 정답을 선택해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("존재하지 않는 결제 이거나 접근 권한이 없습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === 1) setAlert("이미 제출된 시험은 다시 제출할 수 없습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePostExam